// extracted by mini-css-extract-plugin
module.exports = {"card":"SubmissionCard_card__1CMWb"};